import { loadTrashContent, updateTrashContent } from '~/API/job'
import { TRASH_FETCH_LIMIT } from '~/config/constants'
import { RoutePath } from '~/routing'
import { isCurrentLocationMatching } from '~/utilities/navigation'

import type { Middleware } from '../common/actions'
import { FilesDeletionSucceeded, FilesWereAddedToJob } from '../job/actions'
import { timelineReducerMapObj } from '../timeline/reducers'
import { getTimelineJobID } from '../timeline/selectors'

import { FetchMoreTrashTriggered } from './actions'
import { trashReducerMapObj } from './reducer'
import { getTrashFileLatestOffset } from './selectors'

export const trashMiddlewareReducerMapObj = {
    ...timelineReducerMapObj,
    ...trashReducerMapObj,
}

type TrashMiddlewareState = StateOfReducerMapObj<typeof trashMiddlewareReducerMapObj>

export const trashMiddleware: Middleware<TrashMiddlewareState> = (store) => (next) => (action) => {
    if (isCurrentLocationMatching(RoutePath.TrashPhotos)) {
        const state = store.getState()
        const timelineID = getTimelineJobID(state)
        const latestOffset = getTrashFileLatestOffset(state)

        if (
            (FilesDeletionSucceeded.match(action) ||
                (FilesWereAddedToJob.match(action) &&
                    action.payload.files.some((f) => f.is_rollback === true))) &&
            action.payload.jobID === timelineID
        ) {
            void updateTrashContent(store.dispatch, latestOffset, TRASH_FETCH_LIMIT)
        }

        if (FetchMoreTrashTriggered.match(action)) {
            void loadTrashContent(
                store.dispatch,
                latestOffset + TRASH_FETCH_LIMIT,
                TRASH_FETCH_LIMIT,
            )
        }
    }

    return next(action)
}
